import { useEffect, useState } from 'react';
import { promptTemplateApi } from '../../../api/promptTemplateApi';

// Saved prompts are a shared library, so they load once and stay put; a
// failure here only costs the shortcut, not the panel.
export const usePromptTemplates = () => {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    let cancelled = false;
    promptTemplateApi.list()
      .then((list) => { if (!cancelled) setTemplates(Array.isArray(list) ? list : []); })
      .catch((err) => console.warn('Could not load prompt templates:', err.message));
    return () => { cancelled = true; };
  }, []);

  return templates;
};
